import React, {Component} from "react";
import {connect} from "react-redux";
import moment from "moment";
import * as recommendationsActions from "../../../../actions/recommendationsActions";
import LocationInput from "@bit/codeorangex.minerva-ui.ui.location-input";
import CalendarInput from "@bit/codeorangex.minerva-ui.ui.calendar-input";
import SelectInput from "@bit/codeorangex.minerva-ui.ui.select-input";
import "moment/locale/es";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faSearch} from "@fortawesome/free-solid-svg-icons";

moment().locale("es");

class FlightEngine extends Component {
    constructor(props) {
        super(props);

        const { travelItineraryRS : { airItinerary : {
            originDestinationOptions }}} = this.props.bookingInformationReducer;
        const originFS = originDestinationOptions.originDestinationOption[0].flightSegment[0];
        let returnFS = "";
        let endDate = "";
        let destination = "";
        let flighTypeOptionDefault = "RT"
        if(originDestinationOptions.originDestinationOption.length>1){
            returnFS = originDestinationOptions.originDestinationOption[1].flightSegment[0];
            endDate = moment(returnFS.departureDateTime);
            destination = returnFS.departureAirport.locationCode;
        }else{
            const options = originDestinationOptions.originDestinationOption;
            const flightSegments = options[0].flightSegment;
            const refNumberOption = options[options.length - 1].refNumber;

            destination = flightSegments[flightSegments.length-1].arrivalAirport.locationCode;
            flighTypeOptionDefault = (refNumberOption == 1) ? "OR" : "OW"
        }

        this.initialOrigin = originFS.departureAirport.locationCode;
        this.initialDestination = destination;

        this.state = {
            origin: this.initialOrigin,
            destination: this.initialDestination,
            startDate: moment(originFS.departureDateTime),
            endDate:endDate,
            flighTypeOptionDefault: flighTypeOptionDefault
        };

        this.onChangeFlightType(flighTypeOptionDefault);
    }

    onChangeParams = (name, value) => {
        this.setState({
            [name]: value
        });
    };
    onChangeFlightType = (flightType) => {
        this.props.onChangeFlightTypeOptions(flightType);

        if (flightType === "OR") {
            this.setState({
                origin: this.initialDestination,
                destination: this.initialOrigin
            });
        } else {
            this.setState({
                origin: this.initialOrigin,
                destination: this.initialDestination
            });
        }
    };

    onSearchRecommendation = () => {
        const params = {
            origin: this.state.origin,
            destination: this.state.destination,
            startDate: this.state.startDate,
            endDate: this.state.endDate,
            flightTypeOption: this.props.recommendationsReducer.flightTypeOption,
            email: this.props.recommendationsReducer.email,
            ruc: this.props.recommendationsReducer.ruc,
            hasRUC: this.props.recommendationsReducer.hasRUC,
            hasFEE: this.props.recommendationsReducer.hasFEE,
            feeAmount: this.props.recommendationsReducer.feeAmount
        };
        this.props.searchRecommendations(params);
    };

    showActions = () => {
        const { loading } = this.props.recommendationsReducer;
        if (loading) {
            return this.disabledSearchButton();
        } else {
            return this.enabledSearchButton();
        }
    }

    render() {
        const { travelItineraryRS : { airItinerary : { originDestinationOptions }}} = this.props.bookingInformationReducer;
        const options = originDestinationOptions.originDestinationOption;

        let flightTypeOptions = [];

        // Caso RT: dos items con refNumber 0 y 1
        if (options.length === 2 && options[0].refNumber === 0 && options[1].refNumber === 1) {
            flightTypeOptions = [
                { key: "RT", value: "Ida y vuelta" },
                { key: "OW", value: "Solo ida" },
                { key: "OR", value: "Solo Regreso" }
            ];
        }

        // Caso OW: un solo item con refNumber = 0
        if (options.length === 1 && options[0].refNumber === 0) {
            flightTypeOptions = [
                { key: "OW", value: "Solo ida" }
            ];
        }

        // Caso OR: un solo item con refNumber = 1
        if (options.length === 1 && options[0].refNumber === 1) {
            flightTypeOptions = [
                { key: "OR", value: "Solo Regreso" }
            ];
        }

        let {
            origin,
            destination,
            startDate,
            endDate,
            flighTypeOptionDefault
        } = this.state;

        let { flightTypeOption } = this.props.recommendationsReducer;
        let startDateData = {
            label: "Desde...",
            value: startDate
        };
        let endDateClass = "DateInputs";
        if (flightTypeOption !== "RT") {
            startDateData.label = "Para cuando ?";
            endDateClass += " hidden";
        }

        return (
            <div className="row">
                <div className="col-12">
                    <div className="container-box">
                        <div className="FlightEngine">
                            <div className="FlightEngine-header mb-1">
                                <div className="">
                                    <SelectInput
                                        label={"Seleccione"}
                                        options={flightTypeOptions}
                                        selectedKey={flighTypeOptionDefault}
                                        onChange={option =>
                                            this.onChangeFlightType(option.key)
                                        }
                                    />
                                </div>
                            </div>
                            <div className="FlightEngine-engine engine-content">
                                <div className="FlightEngine-form">
                                    <div className="AirportInput">
                                        <LocationInput
                                            key={origin}
                                            id="origin"
                                            label="Desde donde?"
                                            placeholder="Ingrese una ciudad"
                                            location={{
                                                code: origin,
                                                name: origin,
                                                cityName: origin
                                            }}
                                            onChange={option =>
                                                this.onChangeParams("origin", option.cityCode)
                                            }
                                        />
                                    </div>
                                    <div className="AirportInput">
                                        <LocationInput
                                            key={destination}
                                            id="destination"
                                            label="A donde?"
                                            placeholder="Ingrese una ciudad"
                                            location={{
                                                code: destination,
                                                name: destination,
                                                cityName: destination
                                            }}
                                            onChange={option =>
                                                this.onChangeParams("destination", option.cityCode)
                                            }
                                        />
                                    </div>
                                    <div className="DateInputs">
                                        <CalendarInput
                                            id={`calendar-simple`}
                                            label={startDateData.label}
                                            format="ddd DD MMM"
                                            date={startDateData.value}
                                            minDate={moment()}
                                            onChange={({date}) =>
                                                this.onChangeParams("startDate", date)
                                            }
                                        />
                                    </div>
                                    <div className={endDateClass}>
                                        <CalendarInput
                                            id={`end-date`}
                                            label="Hasta..."
                                            format="ddd DD MMM"
                                            minDate={moment()}
                                            date={moment(endDate)}
                                            onChange={({date}) =>
                                                this.onChangeParams("endDate", date)
                                            }
                                        />
                                    </div>
                                    <div className="engine-submit">
                                        {
                                            this.showActions()
                                        }
                                    </div>
                                </div>
                            </div>
                            <div style={{clear: "both"}}> </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    disabledSearchButton() {
        return (<button
            className="btn btn-primary "
            type="submit"
            disabled
        >
            <FontAwesomeIcon icon={faSearch} />
        </button>);
    }

    enabledSearchButton() {
        return (<button
                className="btn btn-primary "
                type="submit"
                onClick={this.onSearchRecommendation}
            >
                <FontAwesomeIcon icon={faSearch} />
            </button>);
    }
}

function mapStateToProps({
                             recommendationsReducer,
                             bookingInformationReducer
                         }) {
    return {
        recommendationsReducer,
        bookingInformationReducer
    };
}

export default connect(mapStateToProps, recommendationsActions)(FlightEngine);
